import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ad575e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-step" }
const _hoisted_2 = {
  key: 0,
  class: "mxa-step-tmp",
  "data-test": "hidden_div"
}
const _hoisted_3 = { class: "d-flex justify-content-center" }
const _hoisted_4 = {
  key: 0,
  class: "mxa-progressbar",
  "data-test": "show_div"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed } from 'vue'

// プロパティ定義

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterStepbar',
  props: {
  // 登録種別
  type: {
    type: String,
    default: '0',
  },
  // active状態
  active: {
    type: Number,
    default: 1,
  },
  // 表示状態
  show: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



/**
 * 選択状態を返す
 */
const isActive = computed(
  () =>
    (type: number): boolean =>
      type === props.active
)

/**
 * 登録種別に対応するデータを取得する
 */
const getTypeData = () => {
  const no = props.type === '0' ? 'body.step.agree.no' : 'body.step.reset.no'
  const title = props.type === '0' ? 'body.step.agree.title' : 'body.step.reset.title'
  return {
    no,
    title,
  }
}

/**
 * 登録種別に対応するパスワード設定画面データを取得する
 */
const getTypeDataEntry = () => {
  const no = 'body.step.entry.no'
  const title = props.type === '0' ? 'body.common.title.entry' : 'body.common.title.reset'
  return {
    no,
    title,
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (props.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["item", { active: _unref(isActive)(1) }]),
              "data-test": "item1"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t(getTypeData().no)), 1),
              _hoisted_5,
              _createTextVNode(_toDisplayString(_ctx.$t(getTypeData().title)), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["item", { active: _unref(isActive)(2) }]),
              "data-test": "item2"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('body.step.onetimepassissue.no')), 1),
              _hoisted_6,
              _createTextVNode(_toDisplayString(_ctx.$t('body.step.onetimepassissue.title')), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["item", { active: _unref(isActive)(3) }]),
              "data-test": "item3"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('body.step.onetimepassauth.no')), 1),
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.$t('body.step.onetimepassauth.title')), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["item", { active: _unref(isActive)(4) }]),
              "data-test": "item4"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t(getTypeDataEntry().no)), 1),
              _hoisted_8,
              _createTextVNode(_toDisplayString(_ctx.$t(getTypeDataEntry().title)), 1)
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})